import styled from 'styled-components';

export const TooltipContentWithLearnMoreWrapper = styled.div`
  a {
    text-decoration: underline;
  }
`;
